import React, { useEffect, useState } from "react";
import styles from "./pd.module.css";
import axios from "axios";
import { url } from "../../../../../../../../../App";
import { useNavigate } from "react-router";
import Pdf from "../../../../../../../../../assets/PDF_file_icon 4.svg";
import PDFViewer from "../../../../../PDFViewer/PDFViewer";
// import { useBorrowerContext } from "../../../../../../store/borrower-details";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ImageDisplay from "./ImageDisplay";
import RecordingDisplay from "./RecordingDisplay";
import VideoPD from "./VideoPD";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useParams } from "react-router-dom";
import { useBorrowerContext } from "../../../../../../store/borrower-details";

const PD = () => {
  const { loanid } = useParams();
  const loanID = loanid;
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const [pdDocsArr, setPdDocsArr] = useState([]);
  const [pdfModal, setPdfModal] = useState({
    open: false,
    data: "",
  });
  const [noDocsFound, setNoDocsFound] = useState(false);
  const [view, setView] = useState(null);
  const [meetingId, setMeetingId] = useState(null);
  const [visible, setvisible] = useState(false);
  const [DeletePdVisible, setDeletePdVisible] = useState(false);
  const token = Cookies.get("Token");
  const email = Cookies.get("Email");
  const { borrowerData } = useBorrowerContext();
  const fetchedLoanDetails = borrowerData.loan;
  const foundLoan = fetchedLoanDetails.find((item) => item.loan_id === loanID);
  const [isDisbursed, setIsDisbursed] = useState(false);

  useEffect(() => {
    if (loanID) {
      setIsDisbursed(foundLoan?.loan_status === "DISBURSED");
    }
    //eslint-disable-next-line
  }, [foundLoan]);

  useEffect(() => {
    if (email === "rupesh.bishnoi@credin.in") {
      setvisible(true);
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email,
        })
        .then((res) => {
          // console.log(res);
          setDeletePdVisible(res.data[0].permission.delete_pd_doc);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [token, email]);

  const fetchPDdocs = async () => {
    try {
      const borrowerReq = {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        borrower_uniqueno: localStorage.getItem("uniqueID"),
      };
      const { data: borrowerDetails } = await axios.post(
        url + "/borrower/borrowertoalldetails",
        borrowerReq
      );
      if (borrowerDetails.logout) {
        navigate("/");
        return;
      }
      if (!borrowerDetails.message.pd) return;
      const currentPD = borrowerDetails.message.pd.find((doc) => {
        return doc.loan_id.toString() === loanID.toString();
      });
      if (!currentPD) {
        setPdDocsArr([]);
        setNoDocsFound(true);
        return;
      }
      setNoDocsFound(false);
      setPdDocsArr(currentPD.pd_doc);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (view === "physical") {
      fetchPDdocs();
    }
    // eslint-disable-next-line
  }, [loanID, view]);

  const fileUploadHandler = async (e) => {
    setOpen(true);
    const { files } = e.target;
    const [file] = files;
    console.log(file);
    if (e.target.files[0] === undefined) {
      setOpen(false);
      return;
    }
    const extension = file.name.split(".")[1];
    if (extension !== "pdf") {
      setOpen(false);
      return toast.error("Please upload a pdf file");
    }
    const formData = new FormData();
    formData.append("file", file);
    formData.append("loan_id", loanID);
    try {
      const { data } = await axios.post(url + "/pd/upload", formData, {
        headers: {
          token: Cookies.get("Token"),
          email: Cookies.get("Email"),
        },
      });
      console.log(data);
      if (!data.auth) {
        setOpen(false);
        return toast.error(data.message);
      }
      fetchPDdocs();
      setOpen(false);
      toast.success(data.message);
    } catch (err) {
      setOpen(false);
      console.log(err);
    }
  };

  const showPDdoc = async (doc) => {
    const request = {
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
      borrower_uniqueno: localStorage.getItem("uniqueID"),
      doc_name: doc.doc_name,
      loan_id: loanID,
      doc_type: "pdf",
    };
    console.log(request);
    const { data: fetchedDocs } = await axios.post(
      url + "/pd/viewdoc",
      request
    );
    console.log(fetchedDocs);
    viewPdfHandler(fetchedDocs.doc_base64);
  };

  const viewPdfHandler = (url) => {
    console.log(url);
    setPdfModal((prevState) => ({
      ...prevState,
      open: true,
      data: `data:application/pdf;base64,${url}`,
    }));
  };

  const closePdfModal = () => {
    setPdfModal((prevState) => ({
      ...prevState,
      open: false,
      data: "",
    }));
  };

  const deleteDocHandler = async (doc) => {
    setOpen(true);
    console.log(doc);
    const text = `Are you sure you want to Delete this Document?`;
    if (!window.confirm(text)) {
      setOpen(false);
      return;
    }
    const deleteReq = {
      token: Cookies.get("Token"),
      email: Cookies.get("Email"),
      borrower_uniqueno: localStorage.getItem("uniqueID"),
      loan_id: loanID,
      doc_arr: {
        location: doc.location,
        doc_type: doc.doc_type,
        doc_name: doc.doc_name,
      },
    };
    const deleteRes = await axios.post(url + "/pd/deletedoc", deleteReq);
    if (!deleteRes.data.auth) {
      setOpen(false);
      toast.error(deleteRes?.data.message);
      return;
    }
    setOpen(false);
    toast.success(deleteRes.data.message);
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  return (
    <>
      <ToastContainer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {pdfModal.open && (
        <PDFViewer url={pdfModal.data} closeModal={closePdfModal} />
      )}
      <div className={styles.mainDiv}>
        <div className={styles.buttonContainer}>
          {!isDisbursed && (
            <button
              onClick={() => setView("video")}
              className={styles.pdButton}
            >
              Video PD
            </button>
          )}
          <button onClick={() => setView("image")} className={styles.pdButton}>
            Video PD Images
          </button>
          <button
            onClick={() => setView("recording")}
            className={styles.pdButton}
          >
            Video PD Recordings
          </button>
          {!isDisbursed && (
            <button
              onClick={() => setView("physical")}
              className={styles.pdButton}
            >
              Physical PD
            </button>
          )}
        </div>
        {view === "physical" && (
          <>
            <div className={styles.loanSelect}>
              <div>
                <input type="file" onChange={fileUploadHandler} />
              </div>
            </div>
            <hr className={styles.hr} />

            <h2 style={{ textAlign: "center" }}>PD Documents</h2>

            <div className={styles.pdfGrid}>
              {pdDocsArr?.map((doc) => (
                <div>
                  <img
                    src={Pdf}
                    alt=""
                    className={styles.docsPDF}
                    key={doc.doc_name}
                    onClick={() => showPDdoc(doc)}
                  />
                  <br></br>
                  {(DeletePdVisible || visible) && (
                    <button
                      className={styles.deleteIcon}
                      onClick={() => deleteDocHandler(doc)}
                      title="Delete Pdf"
                    >
                      Delete
                    </button>
                  )}
                </div>
              ))}
            </div>
            {noDocsFound && (
              <h3 style={{ textAlign: "center" }}>
                No Docs Found. Please select an appropriate Loan Number.
              </h3>
            )}
          </>
        )}
        <div style={{ display: view === "video" ? "block" : "none" }}>
          <VideoPD meetingId={meetingId} setMeetingId={setMeetingId} />
        </div>
        {/* {view === "video" && (
          <VideoPD meetingId={meetingId} setMeetingId={setMeetingId} />
        )} */}
        {view === "image" && <ImageDisplay />}
        {view === "recording" && <RecordingDisplay />}
      </div>
    </>
  );
};

export default PD;
